var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"user-form mb-5"},[_c('form',{attrs:{"id":"user-form"}},[(_vm.error)?_c('div',{staticClass:"form-error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_c('Button',{on:{"click":_vm.login}},[_vm._v("Login")]),_c('br')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }